import makeStyles from '@mui/styles/makeStyles';

const wellnessChangeSidebarStyle = makeStyles(
  {
    sidebarTitle: {
      display: 'flex',
      marginBottom: '24px',
    },
    summary: {
      fontWeight: '500',
      fontSize: '20px',
      lineHeight: '24px',
      letterSpacing: '0.15px',
      color: '#007DFF',
      marginRight: '102px',
    },
    petPlanDetail: {
      borderRadius: '8px',
      padding: '25px',
      marginBottom: '20px',
      backgroundColor: '#EEF0FE',
    },
    petPlanTitle: {
      fontWeight: '700',
      fontSize: '20px',
      lineHeight: '24px',
      letterSpacing: '0.15px',
      color: '#373F51',
    },
    petPlanHeaderContainer: {
      display: 'flex',
      justifyContent: 'space-between',
      marginBottom: '10px',
    },
    planHeader: {
      fontWeight: '600',
      fontSize: '12px',
      lineHeight: '16px',
      letterSpacing: '0.4px',
      color: 'black',
      marginTop: '24px',
    },
    totalValues: {
      fontSize: '14px',
      lineHeight: '20px',
      fontWeight: '400',
      letterSpacing: '0.25px',
      color: 'black',
    },
    finalTotalValues: {
      fontSize: '18px',
      lineHeight: '20px',
      fontWeight: '600',
      letterSpacing: '0.25px',
      color: 'black',
    },
    totalSummary: {
      padding: '20px',
      border: 'solid 1px #E8E8E8',
      borderRadius: '8px',
    },
    margin20v: {
      margin: '20px 0px',
    },
    margin10v: {
      margin: '10px 0px',
    },
  },
  { name: 'wellness-change-sidebar' }
);

export { wellnessChangeSidebarStyle };
